function ExpandableHeader() {
  return null;
}

ExpandableHeader.displayName = 'ExpandableHeader';

export default ExpandableHeader;



// WEBPACK FOOTER //
// ./containers/Expandable/ExpandableHeader.js